class NumbersOnlyInput extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	myOnKeyDown(e) {
		var isDigit = ((e.keyCode >= 48) && (e.keyCode <= 57)) || ((e.keyCode >= 96) && (e.keyCode <= 105));
		var isAllowedDecimal = this.props.allowDecimal && (e.keyCode == 190) && (this.text().indexOf(".") == -1);
		var isControlCharacter = CONTROL_CHARS.indexOf(e.keyCode) != -1;
		var hasModifier = e.ctrlKey || e.metaKey;

		if (!(isDigit || isAllowedDecimal || isControlCharacter || hasModifier)) {
			$wr.nope(e)
		}

		if (this.props.onKeyDown) {
			this.props.onKeyDown(e);
		}
	}

	myOnChange(e) {
		// Don't stress the additional decimal
		var newText = this.text().replace(/[^\d.]/g, "");

		if (newText != this.text()) {
			this.setText(newText);
		} else if (this.props.onChange) {
			this.props.onChange(e);
		}
	}

	text() {
		return this.refs.textfield.value.trim();
	}

	isEmpty() {
		return this.text().length == 0;
	}

	number() {
		if (this.props.allowDecimal) {
			return parseFloat(this.text());
		} else {
			return parseInt(this.text());
		}
	}

	setText(val) {
		this.refs.textfield.value = val;
	}

	render(e) {
		var inputProps = _.omit(this.props, "allowDecimal", "onChange", "onKeyDown");
		var type = this.props.type ? this.props.type : 'number'

		return (
			<input { ...inputProps } ref="textfield" type={type}
				onKeyDown={ this.myOnKeyDown } onChange={ this.myOnChange } />
		)
	}
};

var CONTROL_CHARS = [8, 9, 13, 17, 37, 38, 39, 40, 46];

NumbersOnlyInput.propTypes = StrictPropTypes({
	autoFocus: PropTypes.bool,
	// Allow floats
	allowDecimal: PropTypes.bool,

	// Functions to call if the value changes or there is activity
	onChange: PropTypes.func,
	onKeyDown: PropTypes.func,

	// Props to pass on to input
	placeholder: PropTypes.string,
	className: PropTypes.string,
	defaultValue: PropTypes.number,
	value: PropTypes.number,
	max: PropTypes.number,
	min: PropTypes.number,
	step: PropTypes.number,
	type: PropTypes.string,
});

module.exports = NumbersOnlyInput;



// WEBPACK FOOTER //
// ./modules/components/utility/NumbersOnlyInput.js